/** 
 * Region Selector Script
 * 
 * This script handles region/country detection and selection for the Velocio store.
 * It uses IP geolocation to detect user's country, manages region preferences in localStorage,
 * and controls the region selection dialog UI. 
 * 
 * **/

const RegionSelector = {
    getRegion: () => {
        const itemStr = localStorage.getItem('vel_region');
        if (!itemStr) return null;

        const item = JSON.parse(itemStr);
        if (Date.now() > item.expiry) {
            localStorage.removeItem('vel_region');
            return null;
        }
        return item.value;
    },

    setRegion: (region) => {
        const item = {
            value: region,
            expiry: Date.now() + (90 * 24 * 60 * 60 * 1000)
        };
        localStorage.setItem('vel_region', JSON.stringify(item));
    },

    checkLocation: async (dialogStore) => {
        const response = await fetch('https://get.geojs.io/v1/ip/country.json');
        const ipCountry = await response.json();
        // console.log('ipCountry: ' + ipCountry.country);
        
        if (ipCountry?.country === 'US' && dialogStore === 'velocio-apparel') {
            RegionSelector.setRegion(dialogStore);
            return true;
        }
        return false;
    },

    showDialog: (dialog) => {
        const dialogContent = dialog.querySelector('.region-dialog_content');
        const dialogClose = dialog.querySelector('#region-dialog_close');
        
        setTimeout(() => {
            dialog.show();
            dialogContent?.classList.add('show');
            document.body.style.overflow = 'hidden';
        }, 350);

        dialogClose?.addEventListener('click', () => {
            dialog.close();
            dialogContent?.classList.remove('show');
            document.body.style.overflow = '';
        });

        dialog.addEventListener('click', (e) => {
            if (e.target === dialog) {
                dialog.close();
                dialogContent?.classList.remove('show');
                document.body.style.overflow = '';
            }
        });
    },

    check404: () => {
        if (document.body.classList.contains('template-404')) {
            window.location.href = window.location.origin;
        } else {
            // Remove setStore parameter and clean up URL
            const url = new URL(window.location.href);
            url.searchParams.delete('setStore');
            const newUrl = url.search === '?' ? url.pathname : url.href; // if there is no search params, use the pathname.
            window.history.replaceState({}, '', newUrl);
        }
    }
};

// Initialize the script when the page loads
document.addEventListener('DOMContentLoaded', async () => {
    const dialog = document.getElementById('region-dialog');
    const dialogStore = dialog.getAttribute('data-store');

    // check if the user is setting a location. if so, don't show the dialog
    if (window.location.search.includes('setStore')) {
        // console.log('setting store '+dialogStore);

        // set the region in local storage
        RegionSelector.setRegion(dialogStore);
        RegionSelector.check404();
        return; // stop the DOMContentLoaded function and don't show the dialog
    }

    const region = RegionSelector.getRegion(); // Use this when reading the value

    // Early return if region is valid
    if (region && region === dialogStore) {
        return; // don't show the dialog.
    }
    
    // Continue if region is invalid or expired
    const customerInUS = await RegionSelector.checkLocation(dialogStore);
    if (!customerInUS) {
        RegionSelector.showDialog(dialog);
    }
}); 